import React, { useState } from 'react';
import { useAppContext } from '../App';

const ProductDevSection = () => {
  const { handleProductDevSubmit } = useAppContext();
  const [goal, setGoal] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (goal.trim()) {
      handleProductDevSubmit(goal);
      setGoal('');
    }
  };

  const quickLinks = [
    { icon: '🧪', label: 'Formulation Builder', action: () => handleProductDevSubmit('Formulation Builder') },
    { icon: '📋', label: 'Compliance Check', action: () => handleProductDevSubmit('Compliance Check') },
    { icon: '🔬', label: 'Lab Testing', action: () => handleProductDevSubmit('Lab Testing') }
  ];

  return (
    <div className="product-dev-section">
      <div className="section-header">
        <h3 className="section-title">
          <span className="title-icon">⚗️</span>
          Product Dev Quick-Start
        </h3>
      </div>

      <form onSubmit={handleSubmit} className="dev-form">
        <div className="input-wrapper">
          <input
            type="text"
            className="goal-input"
            placeholder="Enter goal e.g., eco-friendly paint formulation"
            value={goal}
            onChange={(e) => setGoal(e.target.value)}
          />
          <button type="submit" className="submit-btn">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M5 12h14M12 5l7 7-7 7" />
            </svg>
          </button>
        </div>
      </form>

      <div className="quick-links">
        {quickLinks.map((link, index) => (
          <button
            key={index}
            className="quick-link"
            onClick={link.action}
          >
            <span className="link-icon">{link.icon}</span>
            {link.label}
          </button>
        ))}
      </div>

      <style jsx>{`
        .product-dev-section {
          background: linear-gradient(135deg, rgba(59, 130, 246, 0.1) 0%, rgba(6, 182, 212, 0.05) 100%);
          border: 1px solid rgba(59, 130, 246, 0.2);
          border-radius: var(--radius-xl);
          padding: var(--space-lg);
        }

        .section-header {
          margin-bottom: var(--space-md);
        }

        .section-title {
          font-size: var(--font-base);
          font-weight: 600;
          color: var(--color-neutral-50);
          display: flex;
          align-items: center;
          gap: var(--space-sm);
        }

        .title-icon {
          font-size: var(--font-xl);
        }

        .dev-form {
          margin-bottom: var(--space-lg);
        }

        .input-wrapper {
          display: flex;
          align-items: center;
          background: rgba(255, 255, 255, 0.05);
          border: 1px solid rgba(255, 255, 255, 0.15);
          border-radius: var(--radius-lg);
          padding: var(--space-xs);
          transition: all var(--transition-base);
        }

        .input-wrapper:focus-within {
          border-color: var(--color-accent-400);
          box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.15);
        }

        .goal-input {
          flex: 1;
          background: transparent;
          border: none;
          outline: none;
          font-family: var(--font-body);
          font-size: var(--font-sm);
          color: var(--color-neutral-100);
          padding: var(--space-sm) var(--space-md);
        }

        .goal-input::placeholder {
          color: var(--color-neutral-500);
        }

        .submit-btn {
          width: 40px;
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: center;
          background: linear-gradient(135deg, var(--color-accent-500), var(--color-accent-600));
          border: none;
          border-radius: var(--radius-md);
          color: white;
          cursor: pointer;
          transition: all var(--transition-fast);
        }

        .submit-btn:hover {
          background: linear-gradient(135deg, var(--color-accent-400), var(--color-accent-500));
          transform: translateX(2px);
        }

        .quick-links {
          display: flex;
          flex-direction: column;
          gap: var(--space-sm);
        }

        .quick-link {
          display: flex;
          align-items: center;
          gap: var(--space-sm);
          font-family: var(--font-body);
          font-size: var(--font-sm);
          color: var(--color-neutral-300);
          background: rgba(255, 255, 255, 0.05);
          border: 1px solid rgba(255, 255, 255, 0.1);
          border-radius: var(--radius-md);
          padding: var(--space-sm) var(--space-md);
          cursor: pointer;
          transition: all var(--transition-fast);
          text-align: left;
        }

        .quick-link:hover {
          background: rgba(59, 130, 246, 0.1);
          border-color: var(--color-accent-400);
          color: var(--color-accent-300);
        }

        .link-icon {
          font-size: var(--font-lg);
        }
      `}</style>
    </div>
  );
};

export default ProductDevSection;
